import React from 'react';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import Moment from 'moment';
import { Popup } from 'components/Popup/popup';
import { CheckBoxSingle } from 'components/checkboxes/check-box-single';
import { formatTimezoneDateTime } from 'helper/unit-helper';

class CloseReopenPopup extends React.Component {
  static propTypes = {
    onSaveCloseReopenPopup: PropTypes.func,
    onCancelCloseReopenPopup: PropTypes.func,
    lastClosedDate: PropTypes.any
  };

  constructor(props) {
    super(props);
    this.state = {
      lastClosedDate: Moment().format('MM/DD/YYYY'),
      isChecked: false,
      error: null,
      reason: ''
    };
  }

  onChecked = e => {
    e.preventDefault();
    this.setState({
      isChecked: !this.state.isChecked
    });
  };

  onChangeReason = e => {
    this.setState({
      reason: e.target.value,
      reasonError: e.target.value === '' ? 'This field is required' : null
    });
  };

  onChangeDate = lastClosedDate => {
    if (lastClosedDate) {
      if (Moment(lastClosedDate, 'MM/DD/YYYY', true).isValid()) {
        this.setState({
          lastClosedDate,
          error: null
        });
      } else {
        this.setState({
          error: 'Invalid datetime.'
        });
      }
    } else {
      this.setState({
        lastClosedDate
      });
    }
  };

  onSubmit = e => {
    e.preventDefault();
    const { lastClosedDate } = this.props;

    const lastClosedDateParam = lastClosedDate
      ? formatTimezoneDateTime(Moment(lastClosedDate))
      : formatTimezoneDateTime(this.lastClosedDate.state.selectedDate);

    const params = {
      closedReason: this.state.reason.trim(),
      status: 'Closed',
      lastClosedDate: lastClosedDateParam //this.props.lastClosedDate ? this.props.lastClosedDate : this.state.lastClosedDate
    };
    this.props.onSaveCloseReopenPopup(params);
  };

  popupStyle = () => {
    let style = {
      width: 500,
      left: 155,
      paddingLeft: 0
    };
    let offsetTop = 0;
    offsetTop = this.state.reasonError ? offsetTop - 15 : offsetTop;
    offsetTop = this.state.error ? offsetTop - 15 : offsetTop;
    style['top'] = this.props.lastClosedDate
      ? -275 + offsetTop
      : -360 + offsetTop;
    return style;
  };

  render() {
    const disabled = this.props.lastClosedDate
      ? !this.state.isChecked || !this.state.reason
      : !this.state.isChecked ||
        !this.state.lastClosedDate ||
        this.state.error ||
        !this.state.reason;

    return (
      <Popup
        ref={ref => {
          this.resolvePopup = ref;
        }}
        className='close-reopen-popup'
        isHasFaded={true}
        styles={this.popupStyle()}
      >
        <div style={{ paddingTop: 10, paddingBottom: 10 }}>
          {!this.props.lastClosedDate && (
            <div className='form-group' style={{ marginBottom: 0 }}>
              <div className='col-sm-12 col-xs-12'>
                <span
                  className='col-xs-12'
                  style={{ padding: 0, color: '#444', lineHeight: '40px' }}
                >
                  Last closed
                </span>
                <div className='col-xs-12' style={{ padding: 0 }}>
                  <Datetime
                    ref={ref => {
                      this.lastClosedDate = ref;
                    }}
                    inputProps={{ placeholder: 'mm/dd/yyyy' }}
                    value={this.state.lastClosedDate}
                    timeFormat={false}
                    onChange={this.onChangeDate}
                    closeOnSelect={true} />
                  {this.state.error && (
                    <span
                      className='text-danger'
                      style={{
                        fontSize: 12,
                        marginBottom: -10,
                        display: 'inherit'
                      }}
                    >
                      {this.state.error}
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className='form-group'>
            <div className='col-sm-12 col-xs-12'>
              <label className='col-xs-12' style={{ padding: 0 }}>
                Reason
              </label>
              <div className='col-xs-12' style={{ padding: 0 }}>
                <textarea
                  name='reason'
                  ref='reason'
                  className='form-control'
                  placeholder='Your reason'
                  maxLength='1000'
                  value={this.state.reason}
                  onChange={this.onChangeReason}
                  style={
                    this.state.reasonError
                      ? { height: 100, borderColor: '#FF595E' }
                      : { height: 100 }
                  }
                />
                {this.state.reasonError && (
                  <span
                    className='text-danger'
                    style={{
                      fontSize: 12,
                      marginBottom: -10,
                      display: 'inherit'
                    }}
                  >
                    {this.state.reasonError}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div
            className='form-group'
            style={{ marginBottom: 0, padding: 0, marginTop: -20 }}
          >
            <div className='col-sm-12 col-xs-12'>
              <CheckBoxSingle
                ref={c => {
                  this.checkBox = c;
                }}
                checked={this.state.isChecked}
                onChecked={this.onChecked}
                label='I agree that the work order is resolved'
              />
            </div>
          </div>
          <ul
            className='wo-popup-bottom-btn'
            style={{
              padding: '10px 15px 15px 15px',
              borderTop: 0,
              marginTop: -10
            }}
          >
            <li>
              <button
                className='btn btn-primary btn-siteone-default btn-wo-edit'
                onClick={this.props.onCancelCloseReopenPopup}
              >
                Cancel
              </button>
            </li>
            <li>
              <button
                className='btn btn-primary btn-siteone btn-wo-close'
                disabled={disabled}
                onClick={this.onSubmit}
              >
                Save & Close
              </button>
            </li>
          </ul>
        </div>
      </Popup>
    );
  }
}

export default CloseReopenPopup;



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/CloseReopenPopup.js